export default __webpack_public_path__ + "static/media/banner_3000x1250mm.7d1faa7f.png";